import { ReportCoupons } from '@/app/services/reportService/reportCoupons'
import { formatName } from '@/app/utils/formatName'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'

const columnHelper = createColumnHelper<ReportCoupons>()

const columns = [
  columnHelper.accessor('user', {
    id: 'vendedor',
    header: () => (
      <div className="flex w-full flex-col items-start gap-1 pl-2">
        <div>Vendedor</div>
        <div className="block text-black04 md:hidden">Número</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-start gap-1 pl-4">
        <div>
          <p>{formatName(row.original.user)}</p>
        </div>
        <div className="block text-black04 md:hidden">{row.original.code}</div>
      </div>
    ),
  }),
  columnHelper.accessor('code', {
    id: 'code',
    header: () => (
      <div className="hidden text-center md:block">
        <div>Número</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="hidden text-center md:block">
        <div>{row.original.code}</div>
      </div>
    ),
  }),
  columnHelper.accessor('prizedraw', {
    id: 'prizedraw',
    header: () => (
      <div className="flex w-full flex-col items-end gap-1 pr-2 xl:items-center xl:pr-0">
        <div>Sorteio</div>
        <div className="block text-black04 xl:hidden">Data</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-end gap-1 pr-4 xl:items-center xl:pr-0">
        <div>{row.original.prizedraw}</div>
        <div className="block text-black04 xl:hidden">
          {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'data',
    header: () => <div className="hidden text-center xl:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden text-center xl:block">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
]

export const TableReportCouponsColumnsDefinition = () => {
  return {
    columns,
  }
}
